import { render } from "./InventoryTimeLineComponent.vue?vue&type=template&id=2015bab0"
import script from "./InventoryTimeLineComponent.vue?vue&type=script&lang=js"
export * from "./InventoryTimeLineComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__